/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Request to enable or disable a Withings scale feature
 */
export type SetDeviceFeatureMemberRequest = {
    /**
     * The feature mode to enable or disable
     */
    mode: SetDeviceFeatureMemberRequest.mode;
    /**
     * Whether to enable (true) or disable (false) the feature
     */
    enabled: boolean;
    /**
     * The Withings model ID to target
     */
    modelId: number;
};

export namespace SetDeviceFeatureMemberRequest {

    /**
     * The feature mode to enable or disable
     */
    export enum mode {
        EYES_CLOSED = 'EYES_CLOSED',
        BODY_COMPOSITION = 'BODY_COMPOSITION',
    }


}

